&nbsp;
<!-- ****************************************************** 
*** Information for next 5 reservations and quick reservation***
****************************************************** -->
<div>
    <form [formGroup]="availableSlotForm">
        <div class="card">
            <div class="card-header">
                <h3 class="mb-0 title-position" translate>technicalInspection.informationAboutReservations</h3>
            </div>
            <div class="card-body">
                <div class="form-group form-row">
                    <!-- see reservation details button -->
                    <div class="form-group">
                        <button class="btn btn-outline-success ml-2" type="button" routerLink="/list-technical-inspections" *ngIf="perms.hasAccess(perms.CAN_SEARCH_RESERVATIONS)" translate>button.searchDetailsForReservations</button>
                    </div>
                    <!-- table for future reservations and possibility to create one quick  -->
                    <table class="table table-bordered table-striped w-100 center" style=" font-size: 19px">
                        <thead>
                            <tr>
                                <th class="text-center" translate>technicalInspection.date</th>
                                <th class="text-center" translate>technicalInspection.lineNumber</th>
                                <th class="text-center" translate>technicalInspection.regNumber</th>
                                <th class="text-center" translate>technicalInspection.phoneNumber</th>
                                <th class="text-center" translate>technicalInspection.category</th>
                                <th class="text-center" translate>technicalInspection.basicService</th>
                                <th class="text-center" translate>technicalInspection.slot</th>
                                <th class="text-center" translate>actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- table data for future reservations -->
                            <tr *ngFor="let fti of futureTechInspections; let i = index" [ngClass]="{'awaiting-inspection-ping': fti?.status?.code == CODE_AWAITING_INSPECTION}">
                                <td class="text-center">{{fti.inspectionDate}}</td>
                                <td class="text-center">{{fti.techInspectionTimes![0].technicalPointWorkingHours!.line.number}}</td>
                                <td class="text-center">{{fti.regNumber}}</td>
                                <td class="text-center">{{fti.phoneNumber}}</td>
                                <td class="text-center">{{fti.rvsCategory!.description}}</td>
                                <td class="text-center">{{fti.services}}</td>
                                <td class="text-center">{{fti.slot}}</td>
                                <td class="text-center">
                                    <button type="button" *ngIf="isStartedTechInsp && i == 0" disabled="true" class="btn btn-sm btn-primary" translate>button.moved</button>
                                    <button type="button" *ngIf="showLateButton && i == 0 && !isStartedTechInsp" (click)="changeTechInspStatus(fti.id!, 'LATED')" class="btn btn-sm btn-primary" translate>button.late</button>
                                    <button type="button" *ngIf="showStartButton && i == 0 && !isStartedTechInsp" (click)="startTechInspection(fti)" class="btn btn-sm btn-primary ml-1" title="{{'messagebox.moveTechInspData' | translate}}" translate>button.fill</button>
                                    <button type="button" *ngIf="!showStartButton && i == 0 && !isStartedTechInsp" (click)="onSubmitAdditionalFormAnnulModalFutureReservation(fti.id!)" class="btn btn-sm btn-danger" translate>button.annul</button>
                                    <!-- <button type="button" *ngIf="i != 0" (click)="changeTechInspStatus(fti.id!, 'ANNULLED')" class="btn btn-sm btn-danger" translate>button.annul</button> -->
                                    <button type="button" *ngIf="i != 0" (click)="onSubmitAdditionalFormAnnulModalFutureReservation(fti.id!)" class="btn btn-sm btn-danger" translate>button.annul</button>
                                </td>
                            </tr>
                            <br>
                            <!-- Create quick reservation -->
                            <tr class="individual_border">
                                <!-- date -->
                                <td class="text-center">
                                    <div class="input-group mt-1"> 
                                        <input class="form-control d-inline" [minDate]="minDate" style="max-width: 250pt;" aria-describedby="forDate"  formControlName="forDate" 
                                            ngbDatepicker #d1="ngbDatepicker" readonly (dateSelect)='onAvailableSlotDataChange()'>
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary fa fa-calendar" (click)="d1.toggle()" type="button"></button>
                                        </div>
                                    </div>
                                </td>

                                <!-- line -->
                                <td class="text-center">
                                    <select class="custom-select input-custom-size" formControlName="line" [compareWith]="compareById" 
                                            (change)='onAvailableSlotDataChange()'>
                                        <option *ngFor="let line of technicalPointLines" [ngValue]="line">
                                            {{line.number}}
                                        </option>
                                    </select>
                                </td>
                                
                                <!-- reg number -->
                                <td class="text-center">
                                    <input type="text" formControlName="regNumber" class="form-control input-custom-size" placeholder="{{'placeholder.enter' | translate}}"
                                        (focusout)="normalizeRegNumber('slotForm', availableForm.regNumber.value)"
                                        (input)="validateAvailableSlotFormRegNumber(availableForm.regNumber.value)"
                                        [ngClass]="{ 'is-invalid': submittedAvailableSlotForm && availableForm.regNumber.errors || isValidSlotFormRegNum }">
                                    <div class="text-danger" *ngIf="isValidSlotFormRegNum"><small translate>errors.onlyLatinSymbolsAndDigits</small></div>
                                    <ng-container *ngIf="slotFormValidation">
                                        <div class="text-danger" *ngIf="isInvalidRegNumberForForeigner"><small translate>errors.regNumberForForeigner</small></div>
                                        <div class="text-danger" *ngIf="isInvalidRegNumberForDiplomatic"><small translate>errors.regNumberForDiplomatic</small></div>
                                        <div class="text-danger" *ngIf="isInvalidRegNumberForElectric"><small translate>errors.regNumberForElectric</small></div>
                                    </ng-container>
                                    <div class="invalid-feedback" *ngIf="availableForm.regNumber.errors?.required" translate>errors.required</div>
                                    <div class="invalid-feedback" *ngIf="availableForm.regNumber.errors?.maxlength" translate>errors.tooLong</div>
                                </td>

                                <!-- phone number -->
                                <td class="text-center">
                                    <input type="text" formControlName="phoneNumber" class="form-control input-custom-size" placeholder="{{'placeholder.enter' | translate}}"
                                    [ngClass]="{ 'is-invalid': submittedAvailableSlotForm && availableForm.phoneNumber.errors }">  
                                    <div class="invalid-feedback" *ngIf="availableForm.phoneNumber?.errors?.maxlength" translate>errors.tooLong</div>
                                    <div class="invalid-feedback" *ngIf="availableForm.phoneNumber?.errors?.invalidPhoneNumber" translate>errors.phoneInvalid</div>
                                </td>

                                <!-- category -->
                                <td class="text-center">
                                    <select class="custom-select input-custom-size" formControlName="rvsCategory" [compareWith]="compareById" 
                                            (change)='onAvailableSlotRvsCategoryChange()'>
                                        <option *ngFor="let category of rvsCategories" [ngValue]="category">
                                            {{category.description}}
                                        </option>
                                    </select>
                                </td>

                                <!-- basic tech point service -->
                                <td class="text-center">
                                    <select class="custom-select input-custom-size" formControlName="basicTechPointService" [compareWith]="compareById"
                                            (change)='onAvailableSlotDataChange()'>
                                        <option *ngFor="let item of basicServicesForFirstAvailableSlot" [ngValue]="item">
                                            {{item.serviceName}}
                                        </option>
                                    </select>
                                </td>
                                
                                <!-- slots -->
                                <td class="text-center">
                                    <div class="d-flex inline">
                                        <label *ngIf="!groupedTechPointWorkingHours?.length" translate>technicalInspection.noAvailableSlots</label>
                                        <select *ngIf="groupedTechPointWorkingHours?.length" class="custom-select input-custom-size" formControlName="groupedTechPointWorkingHours">
                                            <option *ngFor="let gtpwk of groupedTechPointWorkingHours" [ngValue]="gtpwk">
                                                {{gtpwk.slot}}
                                            </option>
                                        </select>
                                        <button 
                                            [ngClass]="{'clicked': isPastClicked}" 
                                            class="btn btn-success btn-sm ml-1 mt-1 rotate" 
                                            style="height: 36px; width: 30px" 
                                            (click)="loadOldReservations(arePastLoaded, isPastClicked)" translate>
                                            <i class="fa fa-refresh"></i>
                                        </button>
                                    </div>
                                </td>

                                <!-- action -->
                                <td class="text-center">
                                    <button 
                                        *ngIf="groupedTechPointWorkingHours?.length && perms.hasAccess(perms.CAN_ADD_EDIT_TECHNICAL_INSPECTION)" 
                                        class="btn btn-sm btn-primary mt-2" 
                                        (click)="onSubmitAvailableSlotForm()" 
                                        translate>button.save
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </form>
</div>
&nbsp;

<!-- ****************************************************** 
************** Core data for creation *************
****************************************************** -->
<div class="container border mainbox">
    <div>
        &nbsp;
        <h1 class="title-position" translate>technicalInspection.technicalInspection</h1>
        &nbsp;
        
        <!-- Core data about reservation  -->
        <div *ngIf="showAllFields" class="card-body">
            <!-- line number -->
            <div class="row form-group input-custom-size">
                <h4 class="person-label-position" translate>technicalInspection.lineNumber</h4>
                <label class="ml-2 label-size">{{mainForm.lineNumber.value}}</label>
            </div> 

            <!-- slot -->
            <div *ngIf="currentTechnicalInspectionTimes != null" class="row form-group input-custom-size">
                <h4 class="person-label-position" translate>technicalInspection.slotLabel</h4>
                <div class="person-label-position" *ngFor="let ti of currentTechnicalInspectionTimes">
                    <label class="ml-2 label-size">{{ti?.technicalPointWorkingHours?.timeConstraint?.validFrom}} - {{ti?.technicalPointWorkingHours?.timeConstraint?.validTo}}</label>
                </div>
            </div>
            
            <!-- promocode -->
            <div *ngIf="hasPromocode" class="row form-group input-custom-size">
                <h4 class="person-label-position" translate>technicalInspection.promocode</h4>
                <label class="ml-2 label-size">{{getPromoCodeName()}}</label>
            </div> 
            
            <!-- status -->
            <div *ngIf="techInspStatusName !== null" class="row form-group input-custom-size">
                <h4 class="person-label-position" translate>technicalInspection.status</h4>
                <label class="ml-2 label-size">{{techInspStatusName}}</label>
            </div>
            
            <!-- order status -->
            <div *ngIf="technicalInspection?.techInspectionOrders != null" class="row form-group input-custom-size">
                <h4 class="person-label-position"  *ngIf="technicalInspection?.techInspectionOrders![0]?.order != null" translate>technicalInspection.orderStatus</h4>
                <label class="ml-2 label-size">{{technicalInspection.techInspectionOrders![0]?.order?.status?.name}}</label>
            </div>
            
            <!-- payment type -->
            <div *ngIf="technicalInspection?.techInspectionOrders != null" class="row form-group input-custom-size">
                <h4 class="person-label-position"  *ngIf="technicalInspection?.techInspectionOrders![0]?.order != null" translate>technicalInspection.paymentType</h4>
                <label class="ml-2 label-size">{{technicalInspection.techInspectionOrders![0]?.order?.paymentType?.description}}</label>
            </div>
            
            <!-- mobile number -->
            <!-- <div *ngIf="techInspMobileId !== null" class="row form-group input-custom-size">
                <h4 class="person-label-position" translate>technicalInspection.mobileNumber</h4>
                <label class="ml-2 label-size">{{techInspMobileId}}</label>
            </div> -->
            
            <!-- subscription -->
            <div *ngIf="customerSubscriptionName !== null" class="row form-group input-custom-size">
                <h4 class="person-label-position" translate>technicalInspection.subscription</h4>
                <label class="ml-2 label-size">{{customerSubscriptionName}}</label>
            </div>
        </div>

        <!-- Creation data -->
        <div id="accordion" *ngIf="loadTechnicalInspection$ | async as data; else loading">
            <!-- reg number, category and basic service-->
            <form [formGroup]="mainTechInspForm" (ngSubmit)="onSubmitMainForm()">
                <div class="card">
                    <div class="card-header" >
                        <h3 class="mb-0 title-position" translate>technicalInspection.stepOne</h3>
                    </div>
                    <div class="card-body">

                        <!-- ************ Before the review starts ************
                             Only the three fields needed to start one, stacked full width. -->
                        <ng-container *ngIf="!showAllFields">
                            <!-- reg number -->
                            <div class="form-group input-custom-size">
                                <h4 for="regNumber" translate>technicalInspection.registrationNumber</h4>
                                <input class="form-control d-inline input-custom-size" type="text" id="regNumberInput" placeholder="{{'placeholder.enter' | translate}}"
                                    formControlName="regNumber"
                                    (focusout)="normalizeRegNumber('mainForm', mainForm.regNumber.value)"
                                    (input)="validateMainFormRegNumber(mainForm.regNumber.value)"
                                    [ngClass]="{ 'is-invalid': submittedMainForm && mainForm.regNumber.errors || isValidMainFormRegNum}">
                                <div class="text-danger" *ngIf="isValidMainFormRegNum"><small translate>errors.onlyLatinSymbolsAndDigits</small></div>
                                <ng-container *ngIf="mainFormValidation">
                                    <div class="text-danger" *ngIf="isInvalidRegNumberForForeigner"><small translate>errors.regNumberForForeigner</small></div>
                                    <div class="text-danger" *ngIf="isInvalidRegNumberForDiplomatic"><small translate>errors.regNumberForDiplomatic</small></div>
                                    <div class="text-danger" *ngIf="isInvalidRegNumberForElectric"><small translate>errors.regNumberForElectric</small></div>
                                </ng-container>
                                <div class="invalid-feedback" *ngIf="submittedMainForm && mainForm.regNumber.errors?.required" translate>errors.required</div>
                                <div class="invalid-feedback" *ngIf="submittedMainForm && mainForm.regNumber.errors?.maxlength" translate>errors.tooLong</div>
                            </div>

                            <!-- certification number -->
                            <!--<div class="form-group input-custom-size">
                                <h4 for="registrationCertNumber" translate>technicalInspection.certificationNumber</h4>
                                <input type="text" formControlName="registrationCertNumber" class="form-control input-custom-size" placeholder="{{'placeholder.enter' | translate}}"
                                (input)="validateMainFormRegCertNumber(mainForm.registrationCertNumber.value)"
                                [ngClass]="{ 'is-invalid': submittedMainForm && mainForm.registrationCertNumber.errors || isValidMainFormRegCertNum }">
                                <div class="text-danger" *ngIf="isValidMainFormRegCertNum"><small translate>errors.onlyCapitalLatinLettersAndNumbers</small></div>
                                <div class="invalid-feedback" *ngIf="mainForm.registrationCertNumber.errors?.required" translate>errors.required</div>
                                <div class="invalid-feedback" *ngIf="mainForm.registrationCertNumber.errors?.maxlength" translate>errors.tooLong</div>
                            </div> -->

                            <!-- category -->
                            <div class="form-group input-custom-size">
                                <h4 for="rvsCategory" translate>technicalInspection.category</h4>
                                <select class="custom-select input-custom-size" formControlName="rvsCategory" [compareWith]="compareById" (change)='onRvsCategorySelect(mainForm.rvsCategory.value)'
                                        [ngClass]="{ 'is-invalid': submittedMainForm && mainForm.rvsCategory.errors }">
                                    <option *ngFor="let category of rvsCategories" [ngValue]="category">
                                        {{category.description}}
                                    </option>
                                </select>
                                <div class="invalid-feedback" *ngIf="mainForm.rvsCategory.errors?.required" translate>errors.required</div>
                            </div>

                            <!-- basic service - once the review starts this moves to the additional
                                 services section below. -->
                            <div class="form-group input-custom-size">
                                <h4 for="basicTechPointService" translate>technicalInspection.basicServices</h4>
                                <div class="form-check" *ngFor="let item of basicServices">
                                    <input class="form-check-input radio-input-size" formControlName="basicTechPointService" type="radio"
                                        [value]="item" (change)='onBasicTechPointServiceSelect()'
                                        [ngClass]="{ 'is-invalid': submittedMainForm && mainForm.basicTechPointService.errors }" />
                                    <label class="form-check-label radio-label-size ml-2" translate> {{item.serviceName}}</label>
                                </div>
                            </div>
                        </ng-container>

                        <!-- ************ Once the review has started ************
                             The same six fields in two columns of three. The contact details belong
                             to additionalTechInspForm, so each of their columns rebinds to it - the
                             surrounding form is mainTechInspForm. -->
                        <div class="form-row" *ngIf="showAllFields">

                            <!-- left column: reg number, category, phone -->
                            <div class="col-md-6">
                                <!-- reg number -->
                                <div class="form-group input-custom-size">
                                    <h4 for="regNumber" translate>technicalInspection.registrationNumber</h4>
                                    <input class="form-control d-inline input-custom-size" type="text" id="regNumberInput" placeholder="{{'placeholder.enter' | translate}}"
                                        formControlName="regNumber"
                                        (focusout)="normalizeRegNumber('mainForm', mainForm.regNumber.value)"
                                        (input)="validateMainFormRegNumber(mainForm.regNumber.value)"
                                        [ngClass]="{ 'is-invalid': submittedMainForm && mainForm.regNumber.errors || isValidMainFormRegNum}">
                                    <div class="text-danger" *ngIf="isValidMainFormRegNum"><small translate>errors.onlyLatinSymbolsAndDigits</small></div>
                                    <ng-container *ngIf="mainFormValidation">
                                        <div class="text-danger" *ngIf="isInvalidRegNumberForForeigner"><small translate>errors.regNumberForForeigner</small></div>
                                        <div class="text-danger" *ngIf="isInvalidRegNumberForDiplomatic"><small translate>errors.regNumberForDiplomatic</small></div>
                                        <div class="text-danger" *ngIf="isInvalidRegNumberForElectric"><small translate>errors.regNumberForElectric</small></div>
                                    </ng-container>
                                    <div class="invalid-feedback" *ngIf="submittedMainForm && mainForm.regNumber.errors?.required" translate>errors.required</div>
                                    <div class="invalid-feedback" *ngIf="submittedMainForm && mainForm.regNumber.errors?.maxlength" translate>errors.tooLong</div>
                                </div>

                                <!-- email - belongs to additionalTechInspForm, so it rebinds the way
                                     the phone number below it does. Without that it binds against the
                                     surrounding mainTechInspForm, which has no email control, and the
                                     field silently stays empty however it is patched. -->
                                <div class="form-group input-custom-size" [formGroup]="additionalTechInspForm">
                                    <h4 for="emailInput" translate>techPoint.email</h4>
                                    <input class="form-control input-custom-size"  type="text" id="emailInput" placeholder="{{'placeholder.enter' | translate}}"
                                    formControlName="email" [ngClass]="{ 'is-invalid': submittedAdditionalForm && additionalForm.email.errors}">
                                    <div class="invalid-feedback" *ngIf="additionalForm.email?.errors?.email" translate>errors.mailInvalid</div>
                                    <div class="invalid-feedback" *ngIf="additionalForm.email?.errors?.required" translate>errors.required</div>
                                    <div class="invalid-feedback" *ngIf="additionalForm.email?.errors?.maxlength" translate>{{"errors.inputTooLong" | translate: {max: 60} }}</div>
                                </div>

                                <!-- phone number -->
                                <div class="form-group input-custom-size" [formGroup]="additionalTechInspForm">
                                    <h4 for="phoneNumber" translate>technicalInspection.phoneNumber</h4>
                                    <input type="text" formControlName="phoneNumber" placeholder="Пример:+359888112233" class="form-control input-custom-size"
                                    [ngClass]="{ 'is-invalid': submittedAdditionalForm && additionalForm.phoneNumber.errors }">
                                    <div class="invalid-feedback" *ngIf="additionalForm.phoneNumber.errors?.maxlength" translate>errors.tooLong</div>
                                    <div class="invalid-feedback" *ngIf="additionalForm.phoneNumber?.errors?.required" translate>errors.required</div>
                                    <div class="invalid-feedback" *ngIf="additionalForm.phoneNumber?.errors?.invalidPhoneNumber" translate>errors.phoneInvalid</div>
                                </div>
                            </div>

                            <!-- right column: email, subject name, notification + is-employee -->
                            <div class="col-md-6" [formGroup]="additionalTechInspForm">
                                <!-- category - the one field in this column that is not a contact
                                     detail. It lives on mainTechInspForm, which has no rvsCategory
                                     counterpart here, so it rebinds to that group; left on the
                                     surrounding additionalTechInspForm it resolves to no control at
                                     all and the select renders unselected. -->
                                <div class="form-group input-custom-size" [formGroup]="mainTechInspForm">
                                    <h4 for="rvsCategory" translate>technicalInspection.category</h4>
                                    <select class="custom-select input-custom-size" formControlName="rvsCategory" [compareWith]="compareById" (change)='onRvsCategorySelect(mainForm.rvsCategory.value)'
                                            [ngClass]="{ 'is-invalid': submittedMainForm && mainForm.rvsCategory.errors }">
                                        <option *ngFor="let category of rvsCategories" [ngValue]="category">
                                            {{category.description}}
                                        </option>
                                    </select>
                                    <div class="invalid-feedback" *ngIf="mainForm.rvsCategory.errors?.required" translate>errors.required</div>
                                </div>

                                <!-- subject name. input-custom-size belongs on the wrapper, not
                                     only on the input: the validation message underneath takes its
                                     font size from the enclosing block, so without it here this
                                     field's error renders smaller than the email's and phone's. -->
                                <div class="form-group input-custom-size">
                                    <h4 for="nameInput" translate>technicalInspection.subjectName</h4>
                                    <input class="form-control input-custom-size" type="text" id="nameInput" placeholder="{{'placeholder.enter' | translate}}"
                                        formControlName="name" [ngClass]="{ 'is-invalid': submittedAdditionalForm && additionalForm.name.errors}">
                                    <div class="invalid-feedback" *ngIf="additionalForm.name?.errors?.required" translate>errors.required</div>
                                    <div class="invalid-feedback" *ngIf="additionalForm.name?.errors?.maxlength" translate>{{"errors.inputTooLong" | translate: {max: 60} }}</div>
                                </div>

                                <!-- Notification and is-employee share the third row. Their Да/Не
                                     options sit inline rather than stacked, so each block is one
                                     heading plus one row - the same height as a text field above. -->
                                <div class="form-row">
                                    <!-- notification -->
                                    <div class="col form-group input-custom-size">
                                        <h4 translate>technicalInspection.notification</h4>
                                        <!-- form-control-plaintext carries a form control's vertical
                                             padding and transparent borders, so these radios sit on
                                             the same baseline as the inputs beside them. -->
                                        <div class="form-control-plaintext d-flex align-items-center">
                                            <div class="form-check form-check-inline d-flex align-items-center mr-4">
                                                <input class="form-check-input radio-input-size" formControlName="isAgreeWithNotification" type="radio" [value]="true" />
                                                <label class="form-check-label radio-label-size ml-2 mb-0" translate>yes</label>
                                            </div>
                                            <div class="form-check form-check-inline d-flex align-items-center mr-0">
                                                <input class="form-check-input radio-input-size" formControlName="isAgreeWithNotification" type="radio" [value]="false" />
                                                <label class="form-check-label radio-label-size ml-2 mb-0" translate>no</label>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- is employee -->
                                    <div class="col form-group input-custom-size">
                                        <h4 translate>technicalInspection.isEmployee</h4>
                                        <div class="form-control-plaintext d-flex align-items-center">
                                            <div class="form-check form-check-inline d-flex align-items-center mr-4">
                                                <input class="form-check-input radio-input-size" formControlName="isEmployee" type="radio" [value]="true" />
                                                <label class="form-check-label radio-label-size ml-2 mb-0" translate>yes</label>
                                            </div>
                                            <div class="form-check form-check-inline d-flex align-items-center mr-0">
                                                <input class="form-check-input radio-input-size" formControlName="isEmployee" type="radio" [value]="false" />
                                                <label class="form-check-label radio-label-size ml-2 mb-0" translate>no</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button *ngIf="!showAllFields && perms.hasAccess(perms.CAN_ADD_EDIT_TECHNICAL_INSPECTION)" class="btn btn-outline-success" type="button" (click)="onSubmitMainForm()" translate>button.startReview</button>
                    </div>
                </div>
            </form>

            <!-- core -->
            <form [formGroup]="additionalTechInspForm" *ngIf="showAllFields" (ngSubmit)="onSubmitAdditionalForm()">
                <!-- additional and annual services -->
                <div class="card">
                    <div class="card-header">
                        <h3 class="mb-0 title-position" translate> technicalInspection.additionalAndAnnualServices</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group form-row">
                            <!-- basic service - moved here once the review has started. The control
                                 belongs to mainTechInspForm, which is why this subtree rebinds to
                                 it: the surrounding form is additionalTechInspForm. -->
                            <div class="col form-group">
                                <!-- h-100: both cards stretch to the taller of the two, so the
                                     pair reads as one row however many services each holds. -->
                                <div class="card h-100">
                                    <div class="card-header">
                                        <h5 class="mb-0 card-title" translate>technicalInspection.basicServices</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="form-group" [formGroup]="mainTechInspForm">
                                            <div class="form-check" *ngFor="let item of basicServices">
                                                <input class="form-check-input radio-input-size" formControlName="basicTechPointService" type="radio"
                                                    [value]="item" (change)='onBasicTechPointServiceSelect()'
                                                    [ngClass]="{ 'is-invalid': submittedMainForm && mainForm.basicTechPointService.errors }" />
                                                <label class="form-check-label radio-label-size ml-2" translate> {{item.serviceName}}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- additional services -->
                            <div class="col form-group">
                                <div class="card h-100">
                                    <div class="card-header">
                                        <h5 class="mb-0 card-title" translate>technicalInspection.additionalServices</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="form-group">
                                            <!-- The quantity box appears only once the service is
                                                 checked: unchecking is how a service is removed,
                                                 so there is no quantity to show before then. -->
                                            <div class="form-check d-flex align-items-center" *ngFor="let item of additionalServices">
                                                <input type="checkbox" [value]="item"
                                                class="form-check-input mt-2"
                                                [checked]="checkId(item.id)"
                                                (change)="onChangeAdditionalService($event, item)">
                                                <label class="form-check-label checkboxtext"> {{item.serviceName}} </label>
                                                <input *ngIf="checkId(item.id)" type="number" min="1" step="1"
                                                    class="form-control form-control-sm ml-2 service-quantity-input"
                                                    [(ngModel)]="additionalServiceQuantities[item.id!]"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (change)="onChangeAdditionalServiceQuantity(item)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ****************************************************
                     ************** Продажба на стоки *******************
                     The goods sold alongside the inspection. Shown from the moment the review
                     starts and left editable while it is open, so an article can still be added
                     or removed after the inspection is finished. -->
                <div class="card">
                    <div class="card-header">
                        <h3 class="mb-0 title-position" translate>technicalInspection.goods</h3>
                    </div>
                    <div class="card-body">

                        <!-- search -->
                        <input type="text" class="form-control input-custom-size"
                            placeholder="{{'sales.goods.placeholder' | translate}}"
                            [(ngModel)]="itemSearchTerm" [ngModelOptions]="{standalone: true}"
                            (input)="onItemSearchChange(itemSearchTerm)">

                        <div class="d-flex justify-content-center mt-2" *ngIf="catalogLoading">
                            <div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>
                        </div>

                        <!-- results -->
                        <div class="list-group mt-2" *ngIf="catalogResults.length > 0">
                            <div class="list-group-item" *ngFor="let item of catalogResults">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div>{{item.name}}</div>
                                        <small class="text-muted">
                                            <span translate>sales.goods.inventoryId</span> {{item.inventoryId}}
                                            &middot; {{item.sellPrice | number:'1.2-2'}} &euro;
                                            <span *ngIf="item.barcode">&middot; <span translate>sales.goods.barcode</span> {{item.barcode}}</span>
                                        </small>
                                    </div>
                                    <div class="d-flex align-items-center" style="gap: 8px;">
                                        <input type="number" min="1" step="1" class="form-control form-control-sm" style="width: 70px;"
                                            [(ngModel)]="itemQuantities[item.saleItemId]" [ngModelOptions]="{standalone: true}">
                                        <!-- Disabled while this row's stock is being read, so the
                                             same article cannot be added twice over one check. -->
                                        <button class="btn btn-sm btn-primary" type="button"
                                            [disabled]="checkingStockForSaleItemId === item.saleItemId"
                                            (click)="addCatalogItem(item)">
                                            <span class="spinner-border spinner-border-sm mr-1"
                                                *ngIf="checkingStockForSaleItemId === item.saleItemId" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </span>
                                            <span translate>sales.goods.add</span>
                                        </button>
                                    </div>
                                </div>
                                <small class="form-text text-danger" *ngIf="itemMessages[item.saleItemId]">
                                    {{itemMessages[item.saleItemId]}}
                                </small>
                            </div>
                        </div>

                        <!-- the goods on the bill -->
                        <div class="table-responsive mt-3" *ngIf="itemLines.length > 0">
                            <table class="table table-bordered table-striped w-100" style="font-size: 19px">
                                <thead>
                                    <tr>
                                        <th translate>sales.bill.type.item</th>
                                        <th translate>sales.bill.quantity</th>
                                        <th translate>sales.bill.price</th>
                                        <th translate>sales.bill.discount</th>
                                        <th translate>sales.bill.total</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let line of itemLines">
                                        <td>{{line.name}}</td>
                                        <td>{{line.quantity}}</td>
                                        <td>{{itemLineGross(line) | number:'1.2-2'}}</td>
                                        <!-- A text box rather than a number one: the operator types
                                             the discount outright, and the up/down arrows stepping
                                             it by a cent at a time were only ever in the way.
                                             inputmode="decimal" still brings up a numeric keypad on
                                             a touch screen. -->
                                        <td>
                                            <input type="text" inputmode="decimal" class="form-control form-control-sm"
                                                style="width: 90px;"
                                                [ngClass]="{ 'is-invalid': isItemLineDiscountInvalid(line) }"
                                                [(ngModel)]="line.discountInput" [ngModelOptions]="{standalone: true}"
                                                (input)="onItemLineDiscountInput(line)"
                                                (blur)="capItemLineDiscount(line)">
                                            <div class="invalid-feedback d-block" *ngIf="isItemLineDiscountInvalid(line)">
                                                <small>{{ itemLineDiscountError(line) }}</small>
                                            </div>
                                        </td>
                                        <td>{{itemLineTotal(line) | number:'1.2-2'}}</td>
                                        <td>
                                            <button class="btn btn-sm btn-link text-danger" type="button" (click)="removeItemLine(line)">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                <!-- ************ Данни за юридическо лице ************
                 Shown only once the review has started, like the rest of the form - there is
                 nothing to invoice before then. Only the picker until a subject is chosen; its
                 details follow in two columns once one is. 
                -->
                <div class="card" *ngIf="showAllFields">
                    <div class="card-header">
                        <h3 class="mb-0 title-position" translate>technicalInspection.legalEntityData</h3>
                    </div>
                    <div class="card-body">
                        <!-- choose subject -->
                        <h5 *ngIf="isSubjectFromPromocode" style="margin-bottom: 1rem; text-decoration: underline;" translate>technicalInspection.subjectFromPromocode</h5>
                        <div class="form-group">
                            <button class="btn btn-primary" type="button" (click)="openModal()" translate>technicalInspection.chooseSubject</button>
                            <button *ngIf="additionalForm.subjectIdentNum.value != null" class="btn btn-danger ml-2" (click)="clearSubject()" type="button" translate>button.clearSubject</button>
                        </div>
    
                        <!-- Each field is a label/value pair on one grid row, so the values line up
                             in a column of their own and a long address wraps under itself rather
                             than under its label. -->
                        <div class="form-row subject-details" *ngIf="additionalForm.subjectIdentNum.value != null">
                            <!-- left column: bulstat, accountable person, vat number -->
                            <div class="col-md-6">
                                <!-- bulstat -->
                                <div class="subject-field">
                                    <span class="subject-field-label" translate>technicalInspection.bulstat</span>
                                    <span class="subject-field-value">{{additionalForm.subjectIdentNum.value || '-'}}</span>
                                </div>
                                <!-- accountable person -->
                                <div class="subject-field">
                                    <span class="subject-field-label" translate>technicalInspection.accountablePerson</span>
                                    <span class="subject-field-value">{{additionalForm.subjectManager.value || '-'}}</span>
                                </div>
                                <!-- vatNumber -->
                                <div class="subject-field">
                                    <span class="subject-field-label" translate>technicalInspection.vatNumber</span>
                                    <span class="subject-field-value">{{additionalForm.subjectInvoiceDdsReg.value || '-'}}</span>
                                </div>
                            </div>
    
                            <!-- right column: name, place, address -->
                            <div class="col-md-6">
                                <!-- name -->
                                <div class="subject-field">
                                    <span class="subject-field-label" translate>technicalInspection.name</span>
                                    <span class="subject-field-value">{{additionalForm.subjectName.value || '-'}}</span>
                                </div>
                                <!-- place -->
                                <div class="subject-field">
                                    <span class="subject-field-label" translate>technicalInspection.place</span>
                                    <span class="subject-field-value">{{additionalForm.subjectCity?.value?.name || '-'}}</span>
                                </div>
                                <!-- address -->
                                <div class="subject-field">
                                    <span class="subject-field-label" translate>technicalInspection.address</span>
                                    <span class="subject-field-value">{{additionalForm.subjectAddress.value || '-'}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h3 class="mb-0 title-position" translate>technicalInspection.stepTwo</h3>
                    </div>
                    <div class="card-body">
                        <!-- Phone, email, subject name, notification and is-employee are shown in
                             step one once the review has started - see the block beside the
                             "Започни преглед" button. -->

                        <!-- Customer discount autocomplete input (if needed) -->
                        <!-- <div class="form-group">
                            <h4 translate>technicalInspection.discount</h4>
                            <input [attr.disabled]="annualService || disableAnnualServiceAndDiscount"
                                type="text" class="form-control input-custom-size" formControlName="customerDiscount" 
                                [ngbTypeahead]="customerDiscountSearch" [inputFormatter]="customerDiscountFormatter"
                                [resultTemplate]="rtsv" (change)='onCustomerDiscountSelect()'/>
                            <ng-template #rtsv let-r="result" let-t="term">
                                <ngb-highlight [result]="r.discountName" [term]="t"></ngb-highlight>
                            </ng-template>
                        </div> -->

                        <!-- The subject button and its details are in the "Данни за юридическо
                             лице" card above. -->

                        <!-- Mobile Card/Card/Promo Code Input -->
                        <div class="form-group">
                            <h4 for="cardOrPromoCode" translate>technicalInspection.cardOrPromoCode</h4>
                            <div class="d-flex align-items-center">
                                <input class="form-control input-custom-size" type="text" id="cardOrPromoCode" 
                                    placeholder="{{'placeholder.enter' | translate}}"
                                    formControlName="cardOrPromoCode" 
                                    [readonly]="isCardOrPromoCodeReadonly()" />
                                <div *ngIf="isValidatingCardOrPromoCode" class="ml-2">
                                    <div class="spinner-border spinner-border-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </div>
                                <button type="button" class="btn btn-primary ml-2" 
                                    (click)="onApplyCardOrPromoCode()"
                                    [disabled]="isApplyButtonDisabled() || isValidatingCardOrPromoCode"
                                    translate>button.apply</button>
                            </div>
                            
                            <!-- Success Messages -->
                            <div *ngIf="showPromoCodeSuccessMessage" class="alert alert-success mt-2 d-flex align-items-center success-message" role="alert">
                                <span translate>technicalInspection.promoCodeAppliedSuccess</span>
                            </div>
                            <div *ngIf="showCardSuccessMessage" class="alert alert-success mt-2 d-flex align-items-center success-message" role="alert">
                                <span translate>technicalInspection.cardAppliedSuccess</span>
                            </div>
                            <div *ngIf="showMobileCardSuccessMessage" class="alert alert-success mt-2 d-flex align-items-center success-message" role="alert">
                                <span translate>technicalInspection.mobileCardAppliedSuccess</span>
                            </div>
                            
                            <!-- Error Messages -->
                            <span style="color: rgb(206 16 16); font-size: 18px; margin-left: 3px;" *ngIf="displayExceedCardMessage" translate>technicalInspection.displayExceedCardMessage</span>
                            <span style="color: rgb(206 16 16); font-size: 18px; margin-left: 3px;" *ngIf="displayCardDoesNotExistMessage" translate>technicalInspection.displayCardDoesNotExistMessage</span>
                            <span style="color: rgb(206 16 16); font-size: 18px; margin-left: 3px;" *ngIf="displayDiscountAlreadyExistsMessage" translate>technicalInspection.displayDiscountAlreadyExistsMessage</span>
                            <span style="color: rgb(206 16 16); font-size: 18px; margin-left: 3px;" *ngIf="displayNoPermissionForMainServicePromoMessage" translate>technicalInspection.noPermissionForMainServicePromo</span>
                            <span style="color: rgb(206 16 16); font-size: 18px; margin-left: 3px;" *ngIf="displayServiceNotSelectedForDiscountMessage" translate>technicalInspection.serviceNotSelectedForDiscount</span>
                            <span style="color: rgb(206 16 16); font-size: 18px; margin-left: 3px;" *ngIf="displayDiscountCoveredByPromoCampaignMessage" translate>technicalInspection.discountCoveredByPromoCampaign</span>
                        </div>
                        
                        <!-- Applied Discounts Display -->
                        <div class="form-group mt-3" *ngIf="appliedDiscounts.length > 0">
                            <div *ngFor="let appliedDiscount of appliedDiscounts; let i = index" class="mb-2">
                                <div class="d-flex align-items-center justify-content-between p-2" 
                                     style="background-color: #e3f2fd; border: 1px solid #90caf9; border-radius: 4px;">
                                    <span>{{ getAppliedDiscountDisplayText(appliedDiscount) }}</span>
                                    <button type="button" class="btn btn-sm btn-danger ml-2" 
                                            (click)="onRemoveAppliedDiscount(i)"
                                            style="width: 24px; height: 24px; padding: 0; border-radius: 50%; display: flex; justify-content: center;">
                                        <span style="color: white; font-weight: bold;">×</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Discount Dropdown -->
                        <div class="form-group input-custom-size mt-4">
                            <h4 for="rvsCategory" translate>technicalInspection.discount</h4>
                            <select class="custom-select input-custom-size" formControlName="customerDiscount" [compareWith]="compareById" [attr.disabled]="hasPromocode || annualService || disableAnnualServiceAndDiscount" (change)='onCustomerDiscountSelect()'>
                                <option *ngIf="technicalInspection?.techInspectionOrders == null || technicalInspection?.techInspectionOrders![0]?.order?.promotion?.id == null" value="" [attr.disabled]="disableTechPointServices" translate>placeholder.select</option>
                                <option [ngValue]="null" selected translate>placeholder.select</option>
                                <option *ngFor="let discount of customerDiscounts" [ngValue]="discount" [attr.disabled]="disableTechPointServices">
                                    {{ discount.discountName }}
                                </option>
                            </select>
                        </div>

                        <!-- Voucher Code Dropdown -->
                        <div class="form-group input-custom-size mt-4" *ngIf="activeVoucherCodes && activeVoucherCodes.length > 0">
                            <h4 for="voucherCode" translate>technicalInspection.voucherCode</h4>
                            <select class="custom-select input-custom-size" formControlName="voucherCode" [compareWith]="compareVoucherCodeById" (change)="onVoucherCodeSelect()">
                                <option [ngValue]="null" selected translate>placeholder.select</option>
                                <option *ngFor="let voucherCode of activeVoucherCodes" [ngValue]="voucherCode">
                                    {{ voucherCode.code }}
                                </option>
                            </select>
                        </div>

                        <!-- Fiscal receipt number -->
                        <div class="form-group input-custom-size mt-4">
                            <h4 for="fiscalNumber" translate>technicalInspection.fiscalNumber</h4>
                            <!-- The green state confirms the seven digits are in, as they are typed
                                 and without waiting for a save: the operator is copying them off a
                                 paper receipt and has no other way to tell they got all seven. The
                                 field stays optional, so an empty box is left neutral rather than
                                 marked either way. -->
                            <input class="form-control input-custom-size" type="text" id="fiscalNumber"
                                   formControlName="fiscalNumber" maxlength="7"
                                   placeholder="{{'placeholder.enter' | translate}}"
                                   [ngClass]="{ 'is-invalid': submittedAdditionalForm && additionalForm.fiscalNumber.errors,
                                                'is-valid': isFiscalNumberComplete }">
                            <div class="invalid-feedback"
                                 *ngIf="additionalForm.fiscalNumber?.errors?.pattern && submittedAdditionalForm"
                                 translate>errors.fiscalNumberInvalid</div>
                            <div class="valid-feedback d-block" *ngIf="isFiscalNumberComplete"
                                 translate>technicalInspection.fiscalNumberValid</div>
                        </div>

                        <!-- with/without assistant -->
                        <div class="form-group input-custom-size" style="display: none;">
                            <h4 translate>technicalInspection.mannerOfPerformingTheService</h4>
                            <div class="form-check">
                                <label class="radio-inline radio-label-size" translate>
                                    <input class="radio-input-size" type="radio" [value]="1" checked="true"/>  Без асистент
                                </label>
                            </div>

                            <div class="form-check">
                                <label class="radio-inline radio-label-size" translate>
                                    <input class="radio-input-size" type="radio"  [value]="2"/>  С асистент
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header">
                        <h3 class="mb-0 title-position" translate> technicalInspection.stepThree</h3>
                    </div>
                    <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordion">
                        <!-- reject reasons -->
                        <div class="card-body">
                            <div class="form-group input-custom-size">
                                <select class="custom-select input-custom-size" formControlName="rejectReason" [compareWith]="compareById"
                                        (change)='onRejectReasonSelect(additionalForm.rejectReason.value)'>
                                    <option value='' translate>placeholder.select</option>
                                    <option *ngFor="let reason of rejectReasons" [ngValue]="reason">
                                        {{reason.description}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- terminate -->
                    <div class="text-right">
                        <button *ngIf="additionalForm.rejectReason.value != null && canEdit" class="btn btn-outline-success ml-2 mr-2 mb-1" type="button"
                                (click)="onSubmitAdditionalFormTerminatedModal()" [disabled]="disableSaveButton" translate>
                            button.terminate
                        </button>
                    </div>
                </div>
            </form>

            <!-- Payment service table & action buttons
                 Shown from the moment the review starts rather than behind a button: it is priced
                 again on every change that affects what is owed, so it is always current. -->
            <div class="card" *ngIf="showAllFields && isChangedRvsCategory==false">
                <div class="card-header">
                    <h3 class="mb-0 title-position" translate> technicalInspection.stepFour</h3>
                </div>
                
                <!-- Payment service table -->
                <div class="card-body">
                    <div class="form-group form-row">
                        <table class="table table-bordered table-striped w-100" style=" font-size: 19px">
                            <thead>
                                <tr>
                                    <th translate>technicalInspection.itemName</th>
                                    <th translate>technicalInspection.type</th>
                                    <th translate>technicalInspection.quantity</th>
                                    <th translate>technicalInspection.price</th>
                                    <th translate>technicalInspection.discount</th>
                                </tr>
                            </thead>
                        
                            <tbody>
                                <tr *ngFor="let s of paymentServiceConvertedData">
                                    <td>{{s.serviceName}}</td>
                                    <td>{{s.serviceType}}</td>
                                    <td>{{s.quantity}}</td>
                                    <td>{{s.amountDds | number:'1.0-2'}}</td>
                                    <td *ngIf="isNegativeDiscount(s.calculatedDiscount)">+{{s.calculatedDiscount! * -1 | number:'1.0-2'}}</td>
                                    <td *ngIf="!isNegativeDiscount(s.calculatedDiscount)">{{s.calculatedDiscount | number:'1.0-2'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- What the customer owes, summed from the rows above. Each row's price is
                         already net of its discount, so this is the sum of the price column as it
                         is shown - the discount column is there to explain the figures, not to be
                         taken off them a second time. -->
                    <div class="d-flex justify-content-end" *ngIf="paymentServiceConvertedData.length > 0">
                        <h5 class="mb-0"><span translate>technicalInspection.totalAmount</span>: {{paymentTableTotal | number:'1.2-2'}} &euro;</h5>
                    </div>
                </div>

                <ng-container *ngIf="isReservationPaid && orderPriceMismatch">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="mb-0 title-position" translate>Корекция предплатени</h3>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <h5 style="display: flex; align-items: center; justify-content: center; height: 30px; margin-top: 1rem;">
                                    <span style="font-size: 50px; height: 74px;">&#8680;</span>
                                    <span>
                                        Платените услуги са на стойност {{orderAmountPaid | number:'1.2-2'}} евро, след корекцията има за 
                                        <span *ngIf="orderAmountPaid > currentAmountServices">връщане {{(orderAmountPaid - currentAmountServices) | number:'1.2-2'}}</span>
                                        <span *ngIf="currentAmountServices > orderAmountPaid">доплащане {{(currentAmountServices - orderAmountPaid) | number:'1.2-2'}}</span>
                                        евро.
                                    </span>
                                </h5>
                            </div>
                        </div>
                    </div>
                    <br>
                </ng-container>

                <!-- action buttons -->
                <div class="text-right">
                    <button class="btn btn-outline-success mr-1 mb-1" 
                            *ngIf="!hasTechInspectionOrder() && additionalTechInspForm.get('isEmployee')?.value != true && (allowedPaymentTypeDescriptions == null || !allowedPaymentTypeDescriptions.includes(PAYMENT_TYPE_BANK))"
                            type="button" 
                            (click)="onSubmitAdditionalFormAndIssueInvoice()" 
                            [disabled]="disableSaveButton" 
                            translate>button.createAccDoc
                    </button>
                    <button class="btn btn-outline-success mr-1 mb-1" 
                            *ngIf="hasTechInspectionOrder()"
                            type="button" (click)="onSubmitViewInvoice()" 
                            [disabled]="disableSaveButton" 
                            translate>button.viewAccDoc
                    </button>
                    <button class="btn btn-outline-success mr-1 mb-1" 
                            *ngIf="canEdit && showCreditDebitButton"
                            type="button" 
                            (click)="onSubmitViewCreditOrDebit()" 
                            [disabled]="disableSaveButton" 
                            translate>button.viewCreditDebit
                    </button>

                    <button class="btn btn-outline-success mb-1" 
                            *ngIf="additionalTechInspForm.get('isEmployee')?.value != true
                                    && perms.hasAccess(perms.CAN_ADD_EDIT_TECHNICAL_INSPECTION)
                                    && canEdit &&
                                        ((isCredit == false && isDebit == false
                                            && technicalInspection?.techInspectionOrders != null
                                            && technicalInspection?.techInspectionOrders![0]?.order?.paymentType?.description != CARD_PAYMENT_TYPE
                                        ) || technicalInspection?.techInspectionOrders == null)
                                    && allowedPaymentTypeDescriptions != null && allowedPaymentTypeDescriptions.includes(PAYMENT_TYPE_DEFER)"
                            type="button"
                            (click)="onSubmitAdditionalFormDeferPayment()" 
                            [disabled]="disableSaveButton" 
                            translate>
                            button.deferPayment
                    </button>

                    <!-- Bank Payment -->
                    <ng-container *ngIf="!reservationPaidAlready">
                        <button class="btn btn-outline-success mb-1 ml-1" 
                                *ngIf="additionalTechInspForm.get('isEmployee')?.value != true && perms.hasAccess(perms.CAN_ADD_EDIT_TECHNICAL_INSPECTION) && canEdit && (isCredit == false && isDebit == false) && allowedPaymentTypeDescriptions != null && allowedPaymentTypeDescriptions.includes(PAYMENT_TYPE_BANK)"
                                type="button"
                                (click)="onSubmitAdditionalFormBankPayment()" 
                                [disabled]="disableSaveButton" 
                                translate>
                                button.bankPayment
                        </button>
                    </ng-container>

                    <!-- Pay In Tech Point -->
                    <button class="btn btn-outline-success w-20 ml-1 mb-1 mr-2" 
                        *ngIf="additionalTechInspForm.get('isEmployee')?.value == true
                            || (((technicalInspection?.status?.code !== CODE_FINISHED
                                && isCredit == false && isDebit == false
                                && technicalInspection?.techInspectionOrders != null
                                    && technicalInspection?.techInspectionOrders![0]?.order?.paymentType?.description != CARD_PAYMENT_TYPE)
                                || technicalInspection?.techInspectionOrders == null)
                            && isPaymentTypeAllowed(PAYMENT_TYPE_IN_TECH_POINT))"
                        type="button"
                        (click)="onSubmitAdditionalForm()"
                        [disabled]="disableSaveButton">
                        {{ (technicalInspection?.techInspectionOrders != null
                                && technicalInspection?.techInspectionOrders![0]?.order?.status?.code == CODE_PAID
                            ? 'button.finish' : 'button.payInTechPoint') | translate }}
                    </button>

                    <button class="btn btn-outline-success w-20 ml-1 mb-1 mr-2" 
                            [disabled]="disableSaveButton" 
                            *ngIf="technicalInspection?.status?.code == CODE_FINISHED 
                                    && (customerSubscriptionName == null || customerSubscriptionName == undefined) 
                                    && isCredit == false && isDebit == false
                                    || (technicalInspection?.techInspectionOrders != null
                                        && technicalInspection?.techInspectionOrders![0]?.order?.paymentType?.description == CARD_PAYMENT_TYPE
                                        && isCredit == false && isDebit == false)"   
                            type="button"
                            (click)="onSubmitAdditionalFormKeepingPaymentType()"
                            translate>button.save
                    </button>
                    <button class="btn btn-outline-success mr-1 mb-1" 
                            *ngIf="isCredit" 
                            (click)="generateCreditDocument()"
                            type="button" 
                            [disabled]="disableSaveButton" 
                            translate>technicalInspection.createCredit
                    </button>
                    <button class="btn btn-outline-success mr-1 mb-1" 
                            *ngIf="isDebit" 
                            (click)="generateDebitDocument()"
                            type="button" 
                            [disabled]="disableSaveButton" 
                            translate>technicalInspection.createDebit
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
&nbsp;

<ng-template #loading>
    <div *ngIf="errorMessage$ | async as errorMessage; else spinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #spinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>

<ng-template #confirmTermination>
    <h2 mat-dialog-title translate style="font-size: 1.6rem;">button.confirm</h2>
    <mat-dialog-content>
        <p translate style="font-size: 1.1rem;"><p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <div class="text-right">
            <button mat-button [mat-dialog-close]="false" class="btn btn-outline-secondary ml-2 mr-2 mb-1" type="button" 
                (click)="onSubmitAdditionalFormTerminated()" [disabled]="disableSaveButton" translate>
                no
            </button>
            <button mat-button [mat-dialog-close]="true" class="ml-2 mr-2 mb-1 btn btn btn-danger" type="button" 
                (click)="onSubmitAdditionalFormTerminated()" [disabled]="disableSaveButton" translate>
                button.terminate
            </button>
        </div>
    </mat-dialog-actions>
</ng-template>

<ng-template #confirmAnnul>
    <h2 mat-dialog-title translate style="font-size: 1.6rem;">button.confirm</h2>
    <mat-dialog-content>
        <p translate style="font-size: 1.1rem;"><p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <div class="text-right">
            <button mat-button [mat-dialog-close]="false" class="btn btn-outline-secondary ml-2 mr-2 mb-1" type="button" 
                (click)="onSubmitAdditionalFormTerminated()" [disabled]="disableSaveButton" translate>
                no
            </button>
            <button mat-button [mat-dialog-close]="true" class="ml-2 mr-2 mb-1 btn btn btn-danger" type="button" 
                (click)="onSubmitAdditionalFormTerminated()" [disabled]="disableSaveButton" translate>
                button.annul
            </button>
        </div>
    </mat-dialog-actions>
</ng-template>

<ng-template #dataChange>
    <h2 mat-dialog-title translate style="font-size: 1.6rem;">button.change</h2>
    <mat-dialog-content>
        <p translate style="font-size: 1.1rem;">technicalInspection.dataChange<p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <div class="text-right">
            <button mat-button [mat-dialog-close]="true" class="btn btn-outline-secondary ml-2 mr-2 mb-1" type="button" 
                (click)="onDataChangeConfirmationModal()" [disabled]="disableSaveButton" translate>
                messages.ok
            </button>
        </div>
    </mat-dialog-actions>
</ng-template>